import debounce from 'lodash.debounce';
import {buildPersistableClipsPayload, normalizePersistedClips} from '~/utils/video-editor/persistence-utils.js';

export function useVideoEditorStoreSession({clips, file, jobStatus, clipNumber}) {
  let _stopAutoPersist = null;
  let _debouncedPersist = null;

  async function persistEditingSession() {
    if ([VIDEO_EDITOR_STATUS.pending, VIDEO_EDITOR_STATUS.processing, VIDEO_EDITOR_STATUS.errored].includes(jobStatus.value)) {
      return null;
    }

    const clipsPayload = buildPersistableClipsPayload(clips.value);

    return useVideoEditorApi().updateVideoEditorSession({
      fileId: file.value.id,
      clips: clipsPayload,
      status: VIDEO_EDITOR_STATUS.notStarted
    });

    //todo: do we want to show a toast on error?
  }

  async function restoreEditingSession({fileId}) {
    const editSession = await useVideoEditorApi().getVideoEditorSession({fileId});

    if (editSession.clips?.length && ![VIDEO_EDITOR_STATUS.finished, VIDEO_EDITOR_STATUS.notifiedUser].includes(editSession.status)) {
      clips.value = normalizePersistedClips(editSession.clips);
      clipNumber.value = Math.max(...clips.value.map(c => c.clipNumber)) + 1;
    } else {
      clips.value = [];
      clipNumber.value = 0;
    }

    jobStatus.value = editSession.status;

    return clips.value;
  }

  function startAutoPersist() {
    _debouncedPersist = debounce(() => persistEditingSession(), 500);
    _stopAutoPersist = watch(clips, _debouncedPersist, {deep: true});
  }

  function stopAutoPersist() {
    _debouncedPersist?.cancel();
    _stopAutoPersist?.();
    _stopAutoPersist = null;
    _debouncedPersist = null;
  }

  return {
    persistEditingSession,
    restoreEditingSession,
    startAutoPersist,
    stopAutoPersist
  };
}
